import { FrameworkClasses } from '../framework/frameworkClasses';

function classPrefixFromElectronicKeyOrPrefix(electronicKeyOrPrefix: string): string | null {
  const normalized = electronicKeyOrPrefix.trim();
  if (!normalized) return null;

  const colonIndex = normalized.indexOf(':');
  if (colonIndex !== normalized.lastIndexOf(':')) return null;

  const electronicId = colonIndex >= 0 ? normalized.slice(0, colonIndex) : normalized;
  if (!electronicId || (colonIndex >= 0 && !normalized.slice(colonIndex + 1).trim())) return null;

  const dashIndex = electronicId.indexOf('-');
  if (dashIndex >= 0 && !electronicId.slice(dashIndex + 1).trim()) return null;

  const classPrefix = (dashIndex >= 0 ? electronicId.slice(0, dashIndex) : electronicId).trim().toLowerCase();
  return classPrefix || null;
}

/** Resolves a complete electronic key or electronic class prefix to its canonical framework class name. */
export function frameworkClassNameFromElectronicKeyOrPrefix(electronicKeyOrPrefix: string): string | null {
  const classPrefix = classPrefixFromElectronicKeyOrPrefix(electronicKeyOrPrefix);
  if (!classPrefix) return null;

  const frameworkClass = FrameworkClasses.find((candidate) => (candidate.uiPanel ?? candidate.name).toLowerCase() === classPrefix);
  return frameworkClass?.name ?? null;
}
